import { Component, HostListener } from '@angular/core';
import { TranslationService } from '../../../services/translation.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css'
})
export class NavbarComponent {
  isSticky: boolean = false;
  logo: string = 'assets/images/mia-agency/log1.png';

  constructor(private translationService: TranslationService) {}
  
  scrollToSection(sectionId: string) {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  }
  changeLanguage(event: Event): void {
    const selectedLang = (event.target as HTMLSelectElement).value;
    this.translationService.setLanguage(selectedLang);
  }
  translate(key: string): string {
    return this.translationService.translate(key);
  }
  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    if (scrollTop > 100) {  
      this.isSticky = true;
      this.logo = 'assets/images/mia-agency/logBlack.png';
    } else {
      this.isSticky = false;
      this.logo = 'assets/images/mia-agency/log1.png';
    }
  }

  isCollapsed = true;
}
